import React from "react";
import PropTypes from "prop-types";

export const Checkbox = ({ type = "checkbox", name, checked = false, onChange, value, id }) => {
  return <input id={id} type={type} name={name} checked={checked} onChange={onChange} value={value} />;
};

Checkbox.propTypes = {
  type: PropTypes.string,
  name: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  value: PropTypes.string,
  id: PropTypes.string
};
